<template>
  <div class="w-100">
    <div class="header">
      <h3>Motif de la demande d'alignement</h3>
    </div>
    <div class="block-content">
      <div class="form-group">
        <b-row>
          <b-col lg="8" md="3" sm="12" cols="12">
            <b-form-radio-group
              id="MotifAlignement"
              v-model="alignementDemande.reasonRequest"
              name="radio-sub-component"
              :options="motifalignement"
            >
            </b-form-radio-group>
            <b-form-input
              v-if="alignementDemande.reasonRequest == 'Autre'"
              style="margin: 0px !important; width: 350px"
              size="sm"
              placeholder="Précision si autre..."
              v-model="alignementDemande.reasonRequestOther"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-checkbox
              id="checkbox-1"
              v-model="alignementDemande.autorisationUrba"
              name="checkbox-1"
              value="oui"
              unchecked-value="non"
            >
              Demande faisant suite à une autorisation d'urbanisme
            </b-form-checkbox>
          </b-col>
          <b-col lg="1" md="3" sm="12" cols="12">
            <b-form-select
              v-if="alignementDemande.autorisationUrba == 'oui'"
              v-model="alignementDemande.typeDossier"
              :options="optionsUrba"
              v-b-tooltip.hover title="Type de dossier"
            ></b-form-select>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input
              v-if="alignementDemande.autorisationUrba == 'oui'"
              v-model="alignementDemande.dosAutorisationUrba"
              placeholder="Numéro de l'autorisation d'urbanisme"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <p>
            L'arrêté d'alignement ne vaut ni permis de construire, ni
            déclaration de travaux et ne dispense nullement de toute
            autorisation administrative nécessaire à la réalisation des travaux
            projetés
          </p>
        </b-row>
        <b-row>
          <b-col lg="4" md="3" sm="12" cols="12">
            <b-form-checkbox
              id="2"
              v-model="alignementDemande.groundAlreadyRequested"
              value="oui"
              unchecked-value="non"
            >
              Le terrain a déjà fait l'objet d'une demande d'arrêté d'alignement
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="alignementDemande.groundAlreadyRequested == 'oui'">
          <b-col lg="4" md="3" sm="12" cols="12">
            <label>Date de la demande :</label>
            <b-form-datepicker
              hide-header
              :start-weekday="1"
              v-model="alignementDemande.dateRequest"
              placeholder="Date de la demande"
              today-button
              today-button-variant="warning"
              label-help=""
              label-today-button="Aujourd'hui"
            ></b-form-datepicker>
          </b-col>
          <b-col lg="4" md="3" sm="12" cols="12">
            <label>N° de l'arrêté :</label>
            <b-form-input
              v-model="alignementDemande.alignmentOrderNumber"
            ></b-form-input>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "demandeAlignement",
  methods: {
    ...Vuex.mapActions("Cerfa", ["setAlignement"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["alignement"]),
    alignementDemande: {
      get: function() {
        return this.alignement;
      },
      set: function(newValue) {
        this.setAlignement(newValue);
      },
    },
  },
  data() {
    return {
      motifalignement: [
        { text: "Implantation d'un bâtiment", value: "Implantation bat" },
        { text: "Réalisation d'une clôture", value: "Real cloture" },
        { text: "Plantation d'une haie", value: "Plant haie" },
        { text: "Division parcellaire", value: "Division parcellaire" },
        { text: "Travaux sur alignement", value: "Trav alignement" },
        { text: "Autres (à préciser) : ", value: "Autre" },
      ],
      optionsUrba: [
        { value: null, text: " " },
        { value: "PA", text: "PA" },
        { value: "PC", text: "PC" },
        { value: "CU", text: "CU" },
        { value: "DP", text: "DP" },
      ],
    };
  },
};
</script>
